const TYPES = require('reducers/errors').ACTION_TYPES;

function addError(error, errorCode) {
    return {
        type: TYPES.ADD_ERROR,
        error: error,
        errorCode: errorCode
    };
}

function removeError(errorCode) {
    return {
        type: TYPES.REMOVE_ERROR,
        errorCode: errorCode
    };
}

function clearErrors(level) {
    return {
        type: TYPES.CLEAR_ERRORS,
        level: level
    };
}

function validateErrors(errors) {
    return {
        type: TYPES.VALIDATE_ERRORS,
        errors: errors
    };
}

module.exports = {
    TYPES,
    addError,
    removeError,
    clearErrors,
    validateErrors
};
